/* ============================================================
   DNI · Buscador en vivo (índice estático del lado del cliente)
   ------------------------------------------------------------
   Descarga UNA vez `assets/search-index.json` (la "fotocopia del
   inventario") y busca ahí mismo, resolviendo lo que la búsqueda
   nativa de Shopify NO puede:
     - "CONTIENE" real: el fragmento 163 dentro de 8163.
     - SINÓNIMOS / palabras coloquiales (flash -> intermitente).
     - Código OEM equivalente (van en el índice como `codigos`).

   Dos modos de widget [data-live-search]:
     - "dropdown" -> overlay del header: lista flotante de texto,
                     clic navega directo al producto.
     - "grid"     -> página /search: grilla de tarjetas REALES con
                     FOTO (la imagen se pide a /products/{handle}.js,
                     la API nativa de Shopify) y precio, filtrada en
                     vivo mientras se escribe.
   El <form> nativo es el fallback si el JS está apagado.
   ============================================================ */
(function () {
  'use strict';

  var esMayorista = window.DNI_MAYORISTA === true;

  // --- Utilidades ---------------------------------------------------------
  function normaliza(s) {
    return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  }

  function esc(s) {
    return (s || '').replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function pesos(n) { return '$' + Number(n || 0).toLocaleString('es-CL'); }

  // --- Índice: se descarga una sola vez y se comparte ---------------------
  var indicePromise = null;
  var indiceListo = false;
  function cargaIndice(url) {
    if (!indicePromise) {
      indicePromise = fetch(url)
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (items) {
          items.forEach(function (it) {
            it._sku = normaliza(it.sku);
            it._hay = normaliza([
              it.sku, (it.skus || []).join(' '), it.title, it.type,
              (it.codigos || []).join(' '), (it.alias || []).join(' '),
              // Marcas compatibles: sin esto, buscar "opel" o "scania" no
              // devolvía nada aunque el filtro de marca sí las tuviera.
              (it.marcas || []).join(' ')
            ].join(' '));
          });
          indiceListo = true;
          return items;
        })
        .catch(function () {
          // Si la descarga falla (CDN aún propagando, red), NO cacheamos el
          // fallo: liberamos la promesa para que el próximo intento reintente.
          indicePromise = null;
          return [];
        });
    }
    return indicePromise;
  }

  // Un producto entra si TODAS las palabras de la consulta aparecen (contiene).
  function busca(items, q) {
    var tokens = normaliza(q).split(/\s+/).filter(Boolean);
    if (!tokens.length) return [];
    var res = [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i], ok = true;
      for (var t = 0; t < tokens.length; t++) {
        if (it._hay.indexOf(tokens[t]) === -1) { ok = false; break; }
      }
      if (!ok) continue;
      var score = 0, t0 = tokens[0];
      if (it._sku === t0) score += 200;
      else if (it._sku.indexOf(t0) === 0) score += 120;
      else if (it._sku.indexOf(t0) !== -1) score += 60;
      if (normaliza(it.title).indexOf(t0) === 0) score += 40;
      score -= it.title.length * 0.01;
      res.push({ it: it, score: score });
    }
    res.sort(function (a, b) { return b.score - a.score; });
    return res.map(function (r) { return r.it; });
  }

  /* =====================================================================
     MODO DROPDOWN (header) — filas de texto, clic navega al producto
     ===================================================================== */
  function filaHTML(it) {
    var sku = it.sku ? '<span class="sr-sku">' + esc(it.sku) + '</span>' : '';
    var tipo = it.type ? '<span class="sr-type">' + esc(it.type) + '</span>' : '';
    return '<a class="sr-item" href="' + esc(it.url) + '" role="option">' + sku +
      '<span class="sr-main"><span class="sr-title">' + esc(it.title) + '</span>' +
      tipo + '</span></a>';
  }

  function montaDropdown(widget) {
    var input = widget.querySelector('[data-search-input]');
    var results = widget.querySelector('[data-search-results]');
    var url = widget.getAttribute('data-index-url');
    if (!input || !results || !url) return;
    cargaIndice(url); // precarga: la 1ª tecla ya responde

    var LIMITE = 8, timer = null, activo = -1;

    function pinta() {
      if (!input.value.trim()) { results.innerHTML = ''; results.hidden = true; return; }
      cargaIndice(url).then(function (items) {
        var q = input.value; // valor ACTUAL al pintar (robusto ante 1ª carga)
        if (!q.trim()) { results.innerHTML = ''; results.hidden = true; return; }
        var todo = busca(items, q);
        activo = -1;
        if (!todo.length) {
          results.innerHTML = '<div class="sr-empty">Sin coincidencias para “' + esc(q) + '”.</div>';
          results.hidden = false;
          return;
        }
        var html = todo.slice(0, LIMITE).map(filaHTML).join('');
        if (todo.length > LIMITE) {
          html += '<div class="sr-more">+' + (todo.length - LIMITE) + ' más… pulsa Enter para ver todo</div>';
        }
        results.innerHTML = html;
        results.hidden = false;
      });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer); timer = setTimeout(pinta, 110);
    });
    input.addEventListener('focus', function () { if (input.value.trim()) pinta(); });
    input.addEventListener('keydown', function (e) {
      var items = results.querySelectorAll('.sr-item');
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!items.length) return;
        e.preventDefault();
        activo += (e.key === 'ArrowDown' ? 1 : -1);
        if (activo < 0) activo = items.length - 1;
        if (activo >= items.length) activo = 0;
        items.forEach(function (el, i) { el.classList.toggle('is-active', i === activo); });
        items[activo].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && activo >= 0 && items[activo]) {
        e.preventDefault();
        window.location.href = items[activo].getAttribute('href');
      }
    });
    document.addEventListener('click', function (e) {
      if (!widget.contains(e.target)) results.hidden = true;
    });

    if (input.value.trim()) pinta(); // si llega con texto, muestra de una
  }

  /* =====================================================================
     MODO GRID (/search) — tarjetas reales con foto, filtradas en vivo
     ===================================================================== */
  var jsCache = {}; // handle -> promesa de /products/{handle}.js (imagen)

  function imagenDe(handle) {
    if (!jsCache[handle]) {
      jsCache[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return p && p.featured_image ? p.featured_image : null; })
        .catch(function () { return null; });
    }
    return jsCache[handle];
  }

  /* OJO — aquí SÍ se divide, y no contradice al resto del tema.
     En las páginas normales el precio lo entrega Shopify ya con el descuento
     del cliente, así que el tema no calcula. Pero esta grilla se pinta desde
     `search-index.json`, un archivo ESTÁTICO generado del CSV: siempre trae
     el precio de lista. Para que el mayorista no vea aquí un precio distinto
     al de la ficha, se le aplica el mismo 50 %. Si algún día cambia el
     porcentaje del descuento, hay que cambiarlo también aquí. */
  function precioHTML(price) {
    if (!price) return '';
    if (esMayorista) {
      var may = Math.round(price / 2);
      return '<div class="price-row">' +
        '<span class="price-whole-label">Mayorista</span>' +
        '<span class="price price-whole">' + pesos(may) + '</span>' +
        '<s class="price-strike">' + pesos(price) + '</s></div>';
    }
    return '<span class="price">' + pesos(price) + '</span>';
  }

  function imgTag(src) {
    var u = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=600';
    return '<img src="' + esc(u) + '" loading="lazy" alt="" width="600" height="600">';
  }

  function tarjetaHTML(it) {
    var corner = '';
    if (it.voltaje) {
      var vcls = it.voltaje.indexOf('12') !== -1 ? 'v12' : 'v24';
      corner = '<div class="corner"><span class="badge badge-v ' + vcls + '">' + esc(it.voltaje) + '</span></div>';
    }
    var meta = it.type ? '<div class="prod-meta"><span class="badge badge-type">' + esc(it.type) + '</span></div>' : '';
    var code = it.sku ? '<div class="prod-code mono">' + esc(it.sku) + '</div>' : '';
    // Si el índice ya trae la URL de la foto (bakeada), la ponemos de una =>
    // instantánea, sin el viaje extra a /products/{handle}.js. Marcamos
    // data-img para que cargaFotos() NO vuelva a pedirla.
    var imgAttr = '', mediaInner;
    if (it.image) {
      imgAttr = ' data-img="1"';
      mediaInner = imgTag(it.image) + corner;
    } else {
      mediaInner =
        '<div class="ph"></div>' +
        '<div class="ph-code"><div class="c mono">' + esc(it.sku) + '</div><div class="s">cargando…</div></div>' +
        corner;
    }
    return '<a class="prod-card"' + imgAttr + ' href="' + esc(it.url) + '" data-handle="' + esc(it.handle) + '">' +
      '<div class="prod-media" data-media>' + mediaInner + '</div>' +
      '<div class="prod-body">' + code +
        '<div class="prod-name">' + esc(it.title) + '</div>' + meta +
        '<div class="prod-foot">' + precioHTML(it.price) + '</div>' +
      '</div></a>';
  }

  function montaGrid(widget) {
    var input = widget.querySelector('[data-search-input]');
    var grid = widget.querySelector('[data-search-grid]');
    var url = widget.getAttribute('data-index-url');
    if (!input || !grid || !url) return;
    cargaIndice(url);

    var PAGINA = 24, timer = null, mostrados = 0, actuales = [];

    // Rellena la foto real de las tarjetas visibles (una vez).
    function cargaFotos() {
      grid.querySelectorAll('.prod-card[data-handle]:not([data-img])').forEach(function (card) {
        card.setAttribute('data-img', '1');
        var handle = card.getAttribute('data-handle');
        var media = card.querySelector('[data-media]');
        imagenDe(handle).then(function (src) {
          if (!media) return;
          if (src) {
            var corner = media.querySelector('.corner');
            media.innerHTML = imgTag(src);
            if (corner) media.appendChild(corner);
          } else {
            var s = media.querySelector('.ph-code .s');
            if (s) s.textContent = 'imagen producto';
          }
        });
      });
    }

    function pintaMas() {
      var slice = actuales.slice(mostrados, mostrados + PAGINA);
      var wrap = grid.querySelector('.prod-grid');
      wrap.insertAdjacentHTML('beforeend', slice.map(tarjetaHTML).join(''));
      mostrados += slice.length;
      var boton = grid.querySelector('[data-mas]');
      if (mostrados >= actuales.length) { if (boton) boton.remove(); }
      else if (boton) boton.textContent = 'Ver más (' + (actuales.length - mostrados) + ')';
      cargaFotos();
    }

    function render() {
      mostrados = 0;
      // Feedback mientras el índice aún no llega (evita que parezca "no funciona").
      if (!indiceListo && !grid.querySelector('.prod-grid')) {
        grid.innerHTML = '<div class="cat-count" style="margin-bottom:18px;">Cargando productos…</div>';
      }
      cargaIndice(url).then(function (items) {
        // Leemos el valor ACTUAL de la caja al pintar (no una copia previa que
        // pudo quedar vieja mientras el índice cargaba). Esto hace que el
        // PRIMER intento funcione aunque la descarga tarde.
        var q = input.value;
        var vacio = !q.trim();
        // Barra vacía => TODOS los productos; luego se va filtrando al escribir.
        actuales = vacio ? items.slice() : busca(items, q);
        if (!actuales.length) {
          grid.innerHTML =
            '<div class="empty-state"><div class="empty-ic"></div>' +
            '<h3>Sin resultados</h3><p>No encontramos nada para “' + esc(q) +
            '”. Prueba con el código, un nombre más corto o la marca.</p></div>';
          return;
        }
        var restantes = actuales.length - PAGINA;
        var head = vacio
          ? actuales.length + ' productos'
          : actuales.length + ' resultados para “' + esc(q) + '”';
        grid.innerHTML =
          '<div class="cat-count" style="margin-bottom:18px;">' + head + '</div>' +
          '<div class="prod-grid"></div>' +
          (restantes > 0 ? '<button type="button" class="btn btn-navy sr-mas" data-mas>Ver más (' + restantes + ')</button>' : '');
        var boton = grid.querySelector('[data-mas]');
        if (boton) boton.addEventListener('click', pintaMas);
        pintaMas();
      });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer); timer = setTimeout(render, 140);
    });
    // Enter no recarga: filtramos en vivo (el form queda de fallback no-JS).
    var form = widget.querySelector('form');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); render(); });

    render(); // al entrar: muestra todos (o el ?q= si viene con texto)
  }

  /* =====================================================================
     Arranque
     ===================================================================== */
  document.querySelectorAll('[data-live-search]').forEach(function (widget) {
    var modo = widget.getAttribute('data-live-search');
    if (modo === 'grid') montaGrid(widget);
    else montaDropdown(widget);
  });
})();
